const validator = {
    getMessage(field, args) {
        return `O campo ${field} é obrigatório`
    },
    validate(value, args) {
        if (value !== 0 && value !== undefined && value !== null) {
            return true
        } else {
            return false
        }
    }
}

export default validator